import { PaginatedColumn } from '../types/app';
import { DriverStatus } from '../types/drivers';

export const TABLE_COLUMNS_NAME: PaginatedColumn[] = [
  {
    label: '',
    key: 'avatar',
    minWidth: 62,
    maxWidth: 62,
  },
  {
    label: 'Nombre(s)',
    key: 'name',
    minWidth: 250,
  },
  {
    label: 'Apellido(s)',
    key: 'lastName',
    minWidth: 250,
  },
  {
    label: 'Teléfono',
    key: 'phone',
    minWidth: 160,
    maxWidth: 160,
  },
  {
    label: 'Correo electrónico',
    key: 'email',
    minWidth: 160,
    maxWidth: 200,
  },
  {
    label: 'Número de licencia',
    key: 'licenseNumber',
    minWidth: 160,
    maxWidth: 160,
  },
  {
    label: 'Expiración de licencia',
    key: 'licenseExpiry',
    minWidth: 160,
    maxWidth: 160,
  },
  {
    label: 'Creado',
    key: 'createdAt',
    minWidth: 110,
    maxWidth: 110,
  },
  {
    label: 'Actualizado',
    key: 'updatedAt',
    minWidth: 110,
    maxWidth: 110,
  },
  {
    label: 'Acciones',
    key: 'actions',
    minWidth: 120,
    maxWidth: 120,
    centered: true,
  },
];

export const DRIVERS_STATUS = {
  [DriverStatus.recognized.toString()]: 'Identificados',
  [DriverStatus.unknown.toString()]: 'Sin identificar',
};
